import {gql} from '@apollo/client'

export const TRASH = gql`
  query Trash {
    trash {
      folders {
        id
        name
        createdAt
        updatedAt
        deletedAt
      }
      uploads {
        id
        filename
        filesize
        fileType
        status
        folderId
        createdAt
        updatedAt
        deletedAt
      }
    }
  }
`
